import React from 'react'
import moment from 'moment'
import { validate } from 'src/validator'
import { convertRemindCommand } from 'src/converter'

const initialState = {
  toType: 'channel',
  to: '',
  message: '',
  isRepeat: true,
  interval: 'day',
  weeks: {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false
  },
  month: 1,
  day: 1,
  date: moment().format('YYYY-MM-DD'),
  time: {
    ampm: 'am',
    hour: 0,
    minute: 0
  },
  command: '',
  submitted: false,
  errors: []
}

const weekDays = {
  monday: true,
  tuesday: true,
  wednesday: true,
  thursday: true,
  friday: true,
  saturday: false,
  sunday: false
}

const holidays = {
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  saturday: true,
  sunday: true
}

export const AppContext = React.createContext(initialState)

export class AppProvider extends React.Component {
  constructor(props) {
    super(props)
    this.state = initialState
  }

  onChangeInput = (_, { name, value }) => {
    if (this.state.hasOwnProperty(name)) {
      this.setState({ [name]: value })
    }
  }

  onChangeInterval = (event, { value }) => {
    this.onChangeInput(event, { name: 'interval', value })
    if (this.state.interval !== value) {
      this.setState({
        weeks: { ...initialState.weeks }
      })
    }
  }

  setRepeat = isRepeat => {
    this.setState({ isRepeat })
  }

  onChangeInputTime = (_, { name, value }) => {
    if (this.state.time.hasOwnProperty(name)) {
      this.setState({
        time: {
          ...this.state.time,
          [name]: value
        }
      })
    }
  }

  handleClickWeek = key => () => {
    if (this.state.interval === 'otherWeek') {
      this.setState({
        weeks: {
          ...initialState.weeks,
          [key]: true
        }
      })
      return
    }
    this.setState({
      weeks: {
        ...this.state.weeks,
        [key]: !this.state.weeks[key]
      }
    })
  }

  selectWeekDays = () => {
    this.setState({
      weeks: { ...weekDays }
    })
  }

  selectHolidays = () => {
    this.setState({
      weeks: { ...holidays }
    })
  }

  selectTo = key => () => {
    this.setState({
      toType: key,
      to: this.state.to
    })
  }

  onConvert = () => {
    this.setState({
      submitted: true
    })
    const errors = validate(this.state)
    if (errors.length !== 0) {
      this.setState({
        errors: errors
      })
      return
    }

    // 変換処理を実行
    const command = convertRemindCommand(this.state)
    this.setState({
      command,
      errors: []
    })
  }

  render() {
    return (
      <AppContext.Provider
        value={{
          state: {
            ...this.state
          },
          actions: {
            onChangeInput: this.onChangeInput,
            onChangeInterval: this.onChangeInterval,
            onChangeInputTime: this.onChangeInputTime,
            setRepeat: this.setRepeat,
            handleClickWeek: this.handleClickWeek,
            selectWeekDays: this.selectWeekDays,
            selectHolidays: this.selectHolidays,
            selectTo: this.selectTo,
            onConvert: this.onConvert
          }
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    )
  }
}
